<template>
	<div class="dashboard-row">
		<div class="icon-wrapper" aria-hidden="true">
			<svgicon name="expenseCategories/savings"></svgicon>
		</div>
		<div class="title-wrapper">
			<div class="heading-4">{{ $t(item.name) }}</div>
		</div>
		<div class="amount-wrapper">
			<div class="heading-4">{{ item.amount | currency }}</div>
			<div class="body-text-2" :name="item.name">
				<slot name="balance-info"> </slot>
			</div>
		</div>
		<div class="check-wrapper">
			<slot name="icon"> </slot>
		</div>
	</div>
</template>
<script>
import '../icons/expenseCategories/savings';
export default {
	props: {
		item: {
			type: Object,
			default: null
		}
	}
};
</script>
<style lang="scss" scoped>
.dashboard-row {
	display: flex;
	align-items: center;

	.icon-wrapper {
		padding: 24px 16px;

		svg {
			height: 24px;
			width: 24px;
			fill: #a9b7c3;
		}
	}

	.title-wrapper {
		flex-grow: 1;
	}

	.amount-wrapper {
		text-align: right;
		.heading-4 {
			color: $font-blue;
			margin: 0 0 4px 0;
		}

		.body-text-2 {
			color: $font-dark;
		}
		.credit-balance {
			padding-right: 8px;
			margin-right: 8px;
			border-right: 1px solid $font-dark;
		}
	}

	.check-wrapper {
		position: relative;
		padding: 0 32px;

		svg {
			height: 20px;
			width: 20px;
		}
	}
}
</style>
